/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  resetPasswordChange: {
    id: "ResetPasswordChangeSucceededPageComponent.resetPassword",
    defaultMessage: "Your password has been successfully reset.",
  },
  resetPasswordChangeSucceeded: {
    id: "ResetPasswordChangeSucceededPageComponent.resetPasswordSucceeded",
    defaultMessage: "Please login using your new password.",
  },
  resetPasswordChangeButton: {
    id: "ResetPasswordChangeSucceededPageComponent.button",
    defaultMessage: "Login",
  },
});

export default MESSAGES;